import { getLink } from '../../../../utils/utils';

import author from '../rakontoj/author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Сидя в темноте, лишённые возможности что-то делать, мы прожигаем и так скупо отпущенные нам часы и минуты жизни. 
        По чьей-то злой воле, мы не можем распоряжаться своей жизнью и вынуждены делать только то, что нам позволено; а позволено нам мало.
      </p>
        
      <p class="mb-3">
        Т.н. «эпидемия» приучила нас слушаться и бояться; война совсем скрутила нас в бараний рог, практически не оставляя нам свободной воли. 
        Как третья, закономерная стадия этого процесса, должно наступить полное уничтожение, и физическое и духовное, 
        того, что ещё пытается двигаться и шевелиться.
      </p>
      
      <p class="mb-3">
        И тогда – победа! Поле боя зачищено!
      </p>
        
      <p class="mb-3">
        Для кого?
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Мы сжигаем свои жизни, как свечи`
}

const itemDate = {
  rus: `26 января 2023`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

